import React from 'react';
import { Box, Copy, H5 } from '@honda-canada/design-system-react';
import themeStyles from './styles/Shared.styles';
const Container = themeStyles.apply(Box, 'Container');
const Title = themeStyles.apply(H5, 'Title');
const Subtitle = themeStyles.apply(Copy, 'Subtitle');
const BlueBanner = ({ title, subtitle }) => (React.createElement(Container, { "data-testid": "cy-blue-banner" },
    React.createElement(Title, null, title),
    React.createElement(Subtitle, { size: "regular" }, subtitle)));
export default BlueBanner;
